import * as SampleConstants from './constants';
import * as D from './deps';
import SampleReducer from './reducer';
import { watchPlaySample, watchPlaySamples } from './sagas/watchers';
import { externalUtils } from './utils';

export default D.createDomainModule({
  name: SampleConstants.DOMAIN_NAME,
  components: null,
  utils: externalUtils,
  reducer: SampleReducer,
  onStart() {
    this.registeredHandlers = D.registerHandlers([
      {
        actionType: D.Constants.Samples.SamplePlayerActions.PLAY,
        handler: watchPlaySample,
        concur: 'takeLatest',
      },
      {
        actionType: D.Constants.Samples.SamplePlayerActions.PLAY_SAMPLES,
        handler: watchPlaySamples,
        concur: 'takeLatest',
      },
    ]);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
